<template>
  <div>
  	<img style="width: 100%; height: 100%;" src="https://sz.daolongsz.com/static/user.png"/>  
	<div style="height: 1.2rem;">
		  
	</div>
  </div>
  
</template>

<script>

export default {
    data: function () {
    return {

    };
  },
  created() {
	this.$router.push('/');
  },
  mounted: function () {},
  methods: {
    
  },
};
</script>

<style scoped>


</style>